import {
  RESET_ACCOUNTTYPE_REQUESTED,
  RESET_ACCOUNTTYPE_COMPLETED,
} from './types';

const resetAction = () => (dispatch) => {
  dispatch({
    type: RESET_ACCOUNTTYPE_REQUESTED,
  });

  dispatch({
    type: RESET_ACCOUNTTYPE_COMPLETED,
  });
};

export default resetAction;
